import React, { useEffect, useState } from 'react';
import { useApi } from '../../services/ApiServices.tsx'; // Servicio para hacer las solicitudes a la API
import Header from '../../components/Header.tsx';
import Footer from '../../components/Footer.tsx';
import Grid2 from '@mui/material/Grid2/Grid2';
import './Recetas.css';
import { useLocation } from 'react-router-dom';
import DynamicGrid from '../../components/DynamicGrid/DynamicGrid.tsx';
//import CostRangeSlider from '../../components/CostRangeSlider/CostRangeSlider.tsx';
import SideMenu from '../../components/SideMenu/SideMenu.tsx';
import { Category, Option } from '../../interfaces/SideMenu.interface.ts';

import { Button, Collapse, Typography, useMediaQuery, useTheme } from '@mui/material';
import { CarouselItemProps } from '../../interfaces/CaroucelItemProps.interface.ts';
import BannerCarousel from '../../components/BannerCarousel/BannerCarousel.tsx';
import { Banner } from '../../interfaces/Banner.interface.ts';

const tiposComida = require('../../assets/img/side-menu/tipos-comida.png');
const marcas = require('../../assets/img/side-menu/marcas.png');
const preparacion = require('../../assets/img/side-menu/preparacion.png');
const tiemposDelDia = require('../../assets/img/side-menu/tiempos-del-dia.png');
const porPublico = require('../../assets/img/side-menu/por-publico.png');
const temporada = require('../../assets/img/side-menu/temporada.png');
const ingredientes = require('../../assets/img/side-menu/ingredientes.png');

const chilinPreocupado = require('../../assets/img/chilin-preocupado.png');

function Recetas() {
  const { ApiRequest } = useApi();
  const location = useLocation();
  const [recetas, setRecetas] = useState<CarouselItemProps[]>([]);
  const [isLoadingBanner, setIsLoadingBanner] = useState(true);
  const [banners, setBanners] = useState<Banner[]>([]);
  // Obtener los parámetros de la URL
  const params = new URLSearchParams(location.search);
  const tiempo = params.get('tiempo');
  const momento = params.get('momento');
  const categoria = params.get('categoria');
  const searchBox = params.get('SearchBox');
  const usuario = params.get('usuario');

  const theme = useTheme();
  const isMdOrSmaller = useMediaQuery(theme.breakpoints.down('md'));
  const [isCollapsed, setIsCollapsed] = useState(true);

  //const [range, setRange] = useState([0, 15000]);

  const [categories, setCategories] = useState<Category[]>([]);
  const [selectedOptions, setSelectedOptions] = useState<Option[]>([]);

  useEffect(() => {
    const fetchBanners = async () => {
      try {
        setIsLoadingBanner(true);
        const data = await ApiRequest('api/Banner');
        setBanners(data || []);
      } catch (error) {
        console.error('Error fetching baners:', error);
      } finally {
        setIsLoadingBanner(false);
      }
    };

    fetchBanners();
  }, [ApiRequest]);

  const handleClearFilters = () => {
    setSelectedOptions([]);
  };

  const handleSearch = () => {
    performSearch(selectedOptionsByCategory);
  };

  const performSearch = async (options: Record<string, Option[]>) => {
    const params = new URLSearchParams();
  
    Object.entries(options).forEach(([categoryKey, optionsArray]) => {
      optionsArray.forEach(option => {
        switch (categoryKey) {
          case 'ingredientes':
            params.append('categoriaAlimenticia', option.id);
            break;
          case 'temporadas':
            params.append('temporadas', option.id);
            break;
          case 'marcas':
            params.append('marcas', option.id);
            break;
          case 'tiposDeComida':
            params.append('gastronomias', option.id);
            break;
          case 'tiemposDelDia':
            params.append('tiemposDia', option.id);
            break;
          case 'preparacion':
            params.append('clasificacion', option.id);
            break;
          case 'masFitMenosFat':
            params.append('saludables', option.id);
            break;
          case 'alergenos':
            params.append('alergenos', option.id);
            break;
          default:
            console.warn(`Categoría desconocida: ${categoryKey}`);
        }
      });
    });
  
    const queryString = `${params.toString()}`;
    
    try {
      let urlToUse = '';

      urlToUse = `api/Busqueda/BusquedaPorFiltro?${queryString}`;

      const data = await ApiRequest(urlToUse);
      console.log('data:', data);
  
      if (data && Array.isArray(data) && data.length > 0) {
        setRecetas(data);
      } else {
        console.warn('No se recibieron datos válidos');
        setRecetas([]);
      }
    } catch (error) {
      console.error('Error fetching recetas:', error);
      setRecetas([]);
    }
  };

  const selectedOptionsByCategory = categories.reduce<Record<string, Option[]>>((acc, category) => {
    const selectedInCategory = selectedOptions.filter((option) =>
      category.options.some((catOption) => catOption.id === option.id)
    );
    if (selectedInCategory.length > 0) {
      acc[category.id] = selectedInCategory;
    }
    return acc;
  }, {});

  useEffect(() => {
    const getRecetas = async () => {
      try {
        const params = {
          tiempoDiaId: tiempo || null,
          momentoDiaId: momento || null,
          categoriaAlimenticiaId: categoria || null,
          frase: searchBox || null,
          usuario: usuario || null,
        };
    
        const queryString = Object.keys(params)
          .filter((key) => params[key])
          .map((key) => `${key}=${encodeURIComponent(params[key])}`)
          .join('&');
    
        let urlToUse = '';
  
        if(params.frase !== null) {
          urlToUse = `api/Busqueda/Busqueda?${queryString}`;
       // } else if (params.usuario !== null) {
          
        } else if (params.tiempoDiaId === null && params.momentoDiaId === null && params.categoriaAlimenticiaId === null) {
          urlToUse = `api/Busqueda/BusquedaPorFiltro?${queryString}`;
        } else {
          urlToUse = `api/Busqueda/BusquedaDelChef?${queryString}`;
        }
        const data = await ApiRequest(urlToUse);
        console.log('data:', data);
    
        if (data && Array.isArray(data) && data.length > 0) {
          setRecetas(data);
        } else {
          console.warn('No se recibieron datos válidos');
          setRecetas([]);
        }
    
      } catch (error) {
        console.error('Error fetching recetas:', error);
        setRecetas([]);
      }
    }

    getRecetas();

  }, [ApiRequest, categoria, momento, searchBox, tiempo]);

  useEffect(() => {
    const loadCategories = async () => {
      const ingredientsData = await loadIngredients();
      const seasonsData = await loadSeasons();
      const anotherCategoryData = await loadAnotherCategory();
      const tiposComida = await loadTiposComida();
      const byTimeOfDay = await loadByTimeOfDay();
      const byPreparation = await loadByPreparation();
      const masFit = await loadMasFit();
      const alergenos = await loadAlergenos();
      
      // Filtramos los datos válidos y los acumulamos en un array
      const loadedCategories = [
        ingredientsData, 
        seasonsData, 
        anotherCategoryData, 
        tiposComida,
        byTimeOfDay,
        byPreparation,
        masFit,
        alergenos
      ].filter(
        (category): category is Category => category !== null
      );

      // Actualizamos el estado `categories`
      setCategories(loadedCategories);
      };
    
      const loadIngredients = async (): Promise<Category | null> => {
        const data = await ApiRequest('api/Catalogo/ListarCategoriasAlimenticias');
  
        if (data && Array.isArray(data) && data.length > 0) {
          return { id: 'ingredientes', image: ingredientes, title: 'Ingredientes', options: data };
        } else {
          console.warn('No se recibieron datos válidos para Ingredientes');
          return null;
        }
      };

      const loadAlergenos = async (): Promise<Category | null> => {
        const data = await ApiRequest('api/Catalogo/ListarAlergenos');
  
        if (data && Array.isArray(data) && data.length > 0) {
          return { id: 'alergenos', image: '', title: 'Alergenos', options: data };
        } else {
          console.warn('No se recibieron datos válidos para Alergenos');
          return null;
        }
      };
  
      const loadSeasons = async (): Promise<Category | null> => {
        const data = await ApiRequest('api/Catalogo/ListarTemporadas');
  
        if (data && Array.isArray(data) && data.length > 0) {
          return { id: 'temporadas', image: temporada, title: 'Temporadas', options: data };
        } else {
          console.warn('No se recibieron datos válidos para Temporadas');
          return null;
        }
      };
  
      const loadAnotherCategory = async (): Promise<Category | null> => {
        const data = await ApiRequest('api/Catalogo/ListarMarcas');
  
        if (data && Array.isArray(data) && data.length > 0) {
          return { id: 'marcas', image: marcas, title: 'Marcas', options: data };
        } else {
          console.warn('No se recibieron datos válidos para Marcas');
          return null;
        }
      };

      const loadTiposComida = async (): Promise<Category | null> => {
        const data = await ApiRequest('api/Catalogo/ListarGastronomias');
  
        if (data && Array.isArray(data) && data.length > 0) {
          return { id: 'tiposDeComida', image: tiposComida, title: 'Tipos de comida', options: data };
        } else {
          console.warn('No se recibieron datos válidos para Tipos de Comida');
          return null;
        }
      };

      const loadMasFit = async (): Promise<Category | null> => {
        const data = await ApiRequest('api/Catalogo/ListarMasFit');
  
        if (data && Array.isArray(data) && data.length > 0) {
          return { id: 'masFitMenosFat', image: porPublico, title: 'Más fit menos fat', options: data };
        } else {
          console.warn('No se recibieron datos válidos para Mas fit menos fat');
          return null;
        }
      };

      const loadByPreparation = async (): Promise<Category | null> => {
        const data = await ApiRequest('api/Catalogo/ListarClasificacionesDeReceta');
  
        if (data && Array.isArray(data) && data.length > 0) {
          return { id: 'preparacion', image: preparacion, title: 'Preparación', options: data };
        } else {
          console.warn('No se recibieron datos válidos para Preparación');
          return null;
        }
      };

      const loadByTimeOfDay = async (): Promise<Category | null> => {
        const data = await ApiRequest('api/TiemposDia/ListarTiemposDia');
  
        if (data && Array.isArray(data) && data.length > 0) {
          return { id: 'tiemposDelDia', image: tiemposDelDia, title: 'Tiempos del día', options: data };
        } else {
          console.warn('No se recibieron datos válidos para Por Tiempos del Dia');
          return null;
        }
      };

    loadCategories();
  }, []);

  const toggleCollapse = () => {
    setIsCollapsed(!isCollapsed);
  };

  return (
    <Grid2>
        <Header />
            <Grid2 container >
              <Grid2 size={{ sm: 12, md: 3 }}>
                <Grid2 container className='buscador-recetas-container'>
                  <Grid2 size={6}>
                    <Grid2 className='buscador-recetas-title'>Filtros</Grid2>
                  </Grid2>
                  <Grid2 size={6}>
                    {isMdOrSmaller && (
                      <Button onClick={toggleCollapse}>
                        {isCollapsed ? 'Mostrar Filtros' : 'Ocultar Filtros'}
                      </Button>
                    )}
                  </Grid2>
                  <Collapse in={!isMdOrSmaller || !isCollapsed}>
                    <Grid2 size={12} key={''}>
                      <SideMenu categories={categories} selectedOptions={selectedOptions} setSelectedOptions={setSelectedOptions} />
                    </Grid2>
                    <Grid2>
                      <hr />
                    </Grid2>
                    <Grid2 container spacing={2} justifyContent="end">
                      <Button className='buscador-recetas-button-limpiar' variant="contained" color="primary" onClick={handleClearFilters}>
                        Limpiar filtros
                      </Button>
                      <Button className='buscador-recetas-button-buscar' variant="contained" color="primary" onClick={handleSearch}>
                        Buscar
                      </Button>
                    </Grid2>
                  </Collapse>
                  
                </Grid2>
              </Grid2>
                <Grid2 size={{sm: 12, md: 9}}>
                    <Grid2 className='recetas-container'>
                        <Grid2 size={12}>
                            <Grid2 className='recetas-title'>Recetas</Grid2>
                            <Grid2 className='recetas-description'>Descubre los mejores consejos de cocina, limpieza, alimentación y más</Grid2>
                        </Grid2>
                        <Grid2 size={12} key={''}>
                        {recetas && recetas.length > 0 ? (
                          <DynamicGrid items={recetas} />
                        ) : (
                          <Grid2 className={'ups-container'}>
                            <Typography variant="h6" className="ups-title">¡Ups!</Typography>
                            <Typography variant="h6" className="ups">No encontramos ninguna receta que coincida con tu búsqueda. Intenta con otras palabras</Typography>
                            <img
                              src={chilinPreocupado} /* Ruta de tu imagen de 40x40 */
                              alt="preocupado"
                              className="ups-image"
                            />
                          </Grid2>
                        )}
                        </Grid2>
                    </Grid2>
                </Grid2>
            </Grid2>
        <Footer />
    </Grid2>
  );
}

export default Recetas;
